'use strict';

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TrackingConstants, fetchUpdatedFilterState } from '../cfs-search-slice';

import analytics from '../../../../utils/analytics';

const formatPrice = (price) => {
	return price.toLocaleString('en-GB', {
		style: 'currency',
		currency: 'GBP',
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	});
};

export const PriceFilter = () => {
	const priceOptions = [1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 12000, 14000, 16000, 18000, 20000,
		25000, 30000, 35000, 40000, 45000, 50000, 60000, 70000, 80000, 90000, 100000, 120000, 140000, 160000, 200000];

	const defaultValue = '*';
	const dispatch = useDispatch();

	let minPrice = defaultValue;
	let maxPrice = defaultValue;

	const navigatedPrice = useSelector((state) => state.cfsSearch.filterState.navigatedPrice);
	if (navigatedPrice) {
		const prices = navigatedPrice.value.split('-');
		minPrice = prices[0];
		maxPrice = prices[1];
	}

	const updatePriceRange = () => {
		let priceRange;

		if (minPrice !== defaultValue || maxPrice !== defaultValue) {
			priceRange = `${minPrice}-${maxPrice}`;
		}

		dispatch(fetchUpdatedFilterState({
			name: 'price',
			value: priceRange ?? ''
		}));
	};

	const onMinChanged = (e) => {
		minPrice = e.target.value;

		if (minPrice == defaultValue) {
			analytics.trackEvent(TrackingConstants.Categories.Removed, 'priceMin', TrackingConstants.Labels.Unset);
		} else {
			analytics.trackEvent(TrackingConstants.Categories.Added, 'priceMin', minPrice);
		}

		updatePriceRange();
	};

	const onMaxChanged = (e) => {
		maxPrice = e.target.value;

		if (maxPrice == defaultValue) {
			analytics.trackEvent(TrackingConstants.Categories.Removed, 'priceMax', TrackingConstants.Labels.Unset);
		} else {
			analytics.trackEvent(TrackingConstants.Categories.Added, 'priceMax', maxPrice);
		}

		updatePriceRange();
	};

	const minItems = maxPrice === defaultValue
		? priceOptions
		: $.grep(priceOptions, (item) => item <= maxPrice);

	const maxItems = minPrice === defaultValue
		? priceOptions
		: $.grep(priceOptions, (item) => item >= minPrice);

	const minOptions = minItems.map((item) => (
		<option key={item} value={item}>
			{formatPrice(item)}
		</option>
	));

	const maxOptions = maxItems.map((item) => (
		<option key={item} value={item}>
			{formatPrice(item)}
		</option>
	));

	return (
		<div className="search-filters__prices">
			<label>Price from:</label>
			<select className="search-filters__prices__select" onChange={onMinChanged} value={minPrice}>
				<option key={defaultValue} value={defaultValue}>Any price</option>
				{minOptions}
			</select>

			<label>Price to:</label>
			<select className="search-filters__prices__select" onChange={onMaxChanged} value={maxPrice}>
				<option key={defaultValue} value={defaultValue}>Any price</option>
				{maxOptions}
			</select>
		</div>
	);
}